import React from "react";
import useQbBasket from "./useQbBasket";
import { useTranslation } from "react-i18next";
import QbBasketInputs from "./QbBasketInputs";
import { BasketItem } from "../../../models/BasketItem";
import EATable from "../../shared/Table/EATable";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import EAModal from "../../shared/Modal/EAModal";

interface IProps {
  onClose: () => void;
}

const QbBasket: React.FC<IProps> = ({ onClose }) => {
  const { loading, data, updateBasketItem, onUpdateBasket, basketLength, hasDuplicateQbCards, isQbRowDuplicateCard } =
    useQbBasket(onClose);
  const alert = useSelector((state: State) => state.alerts.errors);
  const { t } = useTranslation();
  return (
    <EAModal
      isOpen
      onClose={onClose}
      title="Wykorzystaj promocję do wybranych biletów"
      onAccept={onUpdateBasket}
      loading={loading}
      acceptButtonLabel="Zastosuj promocje"
      disabledAccept={basketLength === 0 || hasDuplicateQbCards}
    >
      <div className="qb-table">
        <EATable
          columns={[
            {
              key: "assortName",
              header: t("nazwa"),
              render: (value, row) => (
                <>
                  <p className="no-line-height">{value}</p>
                  <br />
                  {row.validFrom && (
                    <span className="caption no-line-height">
                      {" "}
                      {t("data_rozpoczecia")}: {row.validFrom}
                    </span>
                  )}
                </>
              ),
            },
            { key: "price", header: t("cena"), type: "price" },
            {
              key: "inputs",
              header: "",
              render: (value, row, index) => (
                <QbBasketInputs
                  index={index}
                  itemData={row as BasketItem}
                  onUpdateBasketItem={updateBasketItem}
                  isDuplicateQbCard={isQbRowDuplicateCard(index)}
                />
              ),
            },
          ]}
          data={data.basket ?? []}
          noDataLabel="Koszyk jest pusty"
        />
      </div>
      {alert && alert.length > 0 && <div className="alert alert-red">{t(alert)}</div>}
    </EAModal>
  );
};

export default QbBasket;
